export class User {
    uid;
    email;
    userName;
}

//export default User;